import { AvatarPlaceholder } from "assets/icons";

import { AvatarProps } from "./Avatar.types";

import styles from "./Avatar.module.scss";

const Avatar = ({
  image,
  Placeholder = AvatarPlaceholder,
  dimensions = { width: 44, height: 44, borderRadius: "50%" },
  ...props
}: AvatarProps) => {
  return (
    <div className={styles.avatar} style={{ ...dimensions }} {...props}>
      {image?.url ? (
        <img
          id={image.url}
          className={styles.avatar_image}
          src={image.url ?? undefined}
        />
      ) : (
        <Placeholder width={dimensions.width} height={dimensions.height} />
      )}
    </div>
  );
};

export default Avatar;
